import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const hasSendingEmailReceiptFailed = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.sendEmailReceipt.hasFailed);
